
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("24Fv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $826b64508233b6c5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gtHL8 = parcelRequire("gtHL8");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $dyvFQ = parcelRequire("dyvFQ");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $173Wl = parcelRequire("173Wl");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $826b64508233b6c5$var$PluggableItems = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("8CzZQ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/pluggable-items/src/ui/main-old.tsx"
});
const $826b64508233b6c5$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gtHL8.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $173Wl.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "apps"
    }));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $826b64508233b6c5$var$AsyncPluggableItems = ()=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionPluggableItems",
        id: "async-pluggable-items",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($826b64508233b6c5$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-pluggable-items",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $173Wl.PluggableItemsFilterButton), {
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($826b64508233b6c5$var$PluggableItems, null)));
};
var $826b64508233b6c5$export$2e2bcd8739ae039 = $826b64508233b6c5$var$AsyncPluggableItems;

});
parcelRegister("173Wl", function(module, exports) {

$parcel$export(module.exports, "PluggableItemsFilterButton", () => $a8d29cea5eb70ad3$export$7f94e3b48172a1bd);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2k6Pt = parcelRequire("2k6Pt");

var $6ZdYp = parcelRequire("6ZdYp");
const $a8d29cea5eb70ad3$export$7f94e3b48172a1bd = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
        testId: "issue-navigator-action-pluggable-items.ui.filter-button.menu-trigger",
        vcId: "pluggable-items",
        text: formatMessage((0, $6ZdYp.default).pluggableItemsButtonText),
        label: formatMessage((0, $6ZdYp.default).pluggableItemsButtonIconLabel),
        ...props,
        ref: ref
    });
});

});
parcelRegister("6ZdYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c576eafb2f38cfa7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c576eafb2f38cfa7$var$messages = (0, $7qGN1.defineMessages)({
    pluggableItemsButtonText: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-text",
        "defaultMessage": "Apps"
    },
    pluggableItemsButtonIconLabel: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-icon-label",
        "defaultMessage": "Open pluggable items dropdown"
    }
});
var $c576eafb2f38cfa7$export$2e2bcd8739ae039 = $c576eafb2f38cfa7$var$messages;

});


parcelRegister("8CzZQ", function(module, exports) {

let $646dcb7ca9658506$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $646dcb7ca9658506$var$load("8sGLg").then(()=>parcelRequire('8jd70'));

});



$parcel$global.rlb("k5rsf")
//# sourceMappingURL=async.ea5daa0c.js.map
